import React from 'react';
import {
  EntityDecision,
  EntityDecisionsParams,
} from '../../entity/entity.types';
import { fetchDecisionByEntities } from '../../entity/entity-lists/entityLists.api';

type State = {
  decisions: Array<EntityDecision>;
};

type Props = {
  params: EntityDecisionsParams;
  children: (decisions: State['decisions']) => React.ReactNode;
};

export class EntityDecisionListFetcher extends React.Component<Props, State> {
  state: State = {
    decisions: [],
  };

  async componentDidMount() {
    const { decisions } = await fetchDecisionByEntities(this.props.params);
    this.setState({ decisions });
  }

  render() {
    return this.props.children(this.state.decisions);
  }
}
